import { useState } from "react"; 
import localimgpath from "../../js/localimgpath";
import CategoriesBtnColor from "../../js/categoriesBtnData";
import {
  Animatespin,
  Navbar,
  MainHeading,
  Experience,
  Footer,
  CategoryDetailCom,
  CategoriesCom,
} from "../../components/index";
import Icons from "../../assets/icon";
import Functions from "./index.function";

const CategoryList = () => {
  const {
    CategoriesTypesMain,
    isLoading,
    Main,
    MainisLoading,
    handleButtonClick,
    categoriesTtypesMainId,
    handleTalent,
  } = Functions();

  const [activeLetter, setActiveLetter] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // 🔍 New state for search

  // 1. Filter categories based on search term
  const filteredCategories = (CategoriesTypesMain || []).filter((item) =>
    item?.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 2. Group only the FILTERED categories
  const groupByAlphabet = (categories = []) => {
    return categories.reduce((acc, item) => {
      const letter = item?.title?.[0]?.toUpperCase() || "#";
      if (!acc[letter]) acc[letter] = [];
      acc[letter].push(item);
      return acc;
    }, {});
  };

  const groupedCategories = groupByAlphabet(filteredCategories);
  const alphabets = Object.keys(groupedCategories).sort();

  return (
    <div className="bg-primary min-h-screen">
      <Navbar />

      <div className="px-3 sm:px-5 lg:px-10 m-auto py-5">
        <MainHeading title={"Categories"} dis={" "} layout={"h-18 sm:h-20 lg:h-36"} navigate={"/"} />

        {isLoading ? (
          <Animatespin />
        ) : (
          <div className="flex flex-col lg:flex-row gap-4">
            
            {/* ================= LEFT: CATEGORY SIDEBAR ================= */}
            <div className="w-full lg:w-64 flex flex-col h-[40vh] lg:h-[80vh] border-b lg:border-b-0 lg:border-r pr-2">
              
              {/* 🔍 SEARCH INPUT */}
              <div className="mb-4 sticky top-0 bg-primary z-20 pb-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search category..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full bg-transparent border border-secondary/30 rounded-md px-3 py-2 text-xs text-secondary focus:outline-none focus:ring-1 focus:ring-orange-500 transition-all"
                  />
                  {searchTerm && (
                    <button 
                      onClick={() => setSearchTerm("")}
                      className="absolute right-2 top-1/2 -translate-y-1/2 text-secondary text-xs"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>

              {/* SCROLLABLE LIST */}
              <div className="flex-1 overflow-y-auto custom-scrollbar">
                {alphabets.length > 0 ? (
                  alphabets.map((letter) => (
                    <div key={letter} id={`section-${letter}`} className="mb-4">
                      <h2 className="text-sm font-bold text-secondary mb-2 sticky top-0 bg-primary z-10">
                        {letter}
                      </h2>
                      <div className="flex flex-col gap-2">
                        {groupedCategories[letter].map((value, index) => (
                          <CategoriesCom
                            key={value.id || index}
                            onClick={() => handleButtonClick(value?.id)}
                            btnTitle={value.title}
                            bgColor={
                          categoriesTtypesMainId === value?.id
                            ? CategoriesBtnColor[index % CategoriesBtnColor.length].activeBgColor
                            : CategoriesBtnColor[index % CategoriesBtnColor.length].bgColor
                        }
                        btnIcon={
                          value?.icon
                            ? `${localimgpath?.categoryIcons}/${value?.icon}`
                            : Icons.directorChairIcon
                        }
                        CateclassName={`w-full justify-start px-3 py-2 text-xs flex items-center gap-2 ${
                          categoriesTtypesMainId === value?.id ? "ring-2 ring-orange-500" : ""
                        }`}
                        // CateclassName={`w-full justify-start px-3 py-2 text-xs rounded-md shadow flex items-center gap-2 ${
                        //   categoriesTtypesMainId === value?.id ? "ring-2 ring-orange-500" : ""
                        // }`}
                        fontClassname="font-onestSemiBold"
                        iconlayout="w-4 h-4"
                        alt={value?.title}
                          />

                           
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-xs text-secondary/50 text-center py-5">No categories found</p>
                )}
              </div>
            </div>

            {/* ================= MIDDLE: ALPHABET MENU ================= */}
            {/* We hide the alphabet menu if the user is searching to avoid confusion */}
            {!searchTerm && (
              <div className="hidden lg:flex w-[40px] h-[80vh] flex-col items-center custom-scrollbar">
                {alphabets.map((letter) => (
                  <button
                    key={letter}
                    onClick={() => {
                      setActiveLetter(letter);
                      document.getElementById(`section-${letter}`)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className={`text-xs py-1 transition-colors ${activeLetter === letter ? "text-orange-500 font-bold" : "text-secondary"}`}
                  >
                    {letter}
                  </button>
                ))}
              </div>
            )}

            {/* ================= RIGHT: TALENT GRID ================= */}
            <div className="flex-1 h-[60vh] lg:h-[80vh] overflow-y-auto custom-scrollbar px-1">
              {/* ================= RIGHT: TALENT GRID ================= */}
 
                <div className="flex-1 h-[60vh] lg:h-[80vh] overflow-y-auto custom-scrollbar px-1">
                {MainisLoading ? (
                  <Animatespin />
                ) : Main?.talent?.length < 1 ? (
                  <p className="text-secondary text-center mt-5">Data not available</p>
                ) : (
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
                    {Main?.talent.map((value, index) => (
                      <CategoryDetailCom
                        key={value.id || index}
                        onClick={() => handleTalent(value?.id)}
                        latestNewsthubmail={`${localimgpath?.talentThumbnail}/${value?.hero_image}`}
                        latestNewsTitle={value?.real_name}
                        alt={value?.stage_name}
                        position={value?.news_title}
                        bgcolor={CategoriesBtnColor[index % CategoriesBtnColor.length].bgColor}
                      />
                    ))}
                  </div>
                )}
              </div> 

            </div>

          </div>
        )}
      </div>

      <Experience />
      <Footer />
    </div>
  );
};

export default CategoryList;